import React from 'react';
import { Ticket, TicketReply, TICKET_CATEGORY_CONFIG, TICKET_STATUS_CONFIG, TICKET_PRIORITY_CONFIG } from './types';


interface TicketSidebarProps {
  ticket: Ticket;
  replies: TicketReply[];
  isTeamMember?: boolean;
}

export const TicketSidebar: React.FC<TicketSidebarProps> = ({
  ticket, replies,
}) => {
  const fmtDate = (d?: string | null) => {
    if (!d) return '—';
    const date = new Date(d);
    return `${date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} at ${date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}`;
  };

  const DetailsBlock = (
    <div className="bg-card border border-border rounded-xl p-5 space-y-4">
      <div className="pb-4 mb-2 border-b border-border/50">
        <h2 className="text-[15px] font-bold text-foreground leading-snug">{ticket.subject}</h2>
      </div>
      <DetailRow label="Ticket ID" value={`#${ticket.ticket_number}`} />
      {ticket.client && <DetailRow label="Customer" value={ticket.client.name} />}
      {!ticket.client && ticket.creator && <DetailRow label="Opened By" value={ticket.creator.name} />}
      <DetailRow label="Topic" value={TICKET_CATEGORY_CONFIG[ticket.category]?.label || ticket.category} />
      
      <DetailRow label="Status" value={
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${TICKET_STATUS_CONFIG[ticket.status]?.color || 'bg-muted text-muted-foreground'}`}>
          {TICKET_STATUS_CONFIG[ticket.status]?.label || ticket.status}
        </span>
      } />
      
      <DetailRow label="Priority" value={
        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${TICKET_PRIORITY_CONFIG[ticket.priority]?.color || 'bg-muted text-muted-foreground'}`}>
          <span className={`w-1.5 h-1.5 rounded-full mr-1.5 ${TICKET_PRIORITY_CONFIG[ticket.priority]?.dotColor || 'bg-muted-foreground'}`} />
          {TICKET_PRIORITY_CONFIG[ticket.priority]?.label || ticket.priority}
        </span>
      } />
      
      <DetailRow label="Total Responses" value={replies.length} />
      <DetailRow label="Created At" value={fmtDate(ticket.created_at)} />
      <DetailRow label="Last Updated" value={fmtDate(ticket.updated_at)} />
      {ticket.resolved_at && <DetailRow label="Resolved At" value={fmtDate(ticket.resolved_at)} />}
    </div>
  );

  return (
    <div className="w-full">
      {DetailsBlock}
    </div>
  );
};

const DetailRow: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="flex justify-between items-center gap-4">
    <span className="text-[13px] text-muted-foreground font-medium">{label}:</span>
    <span className="text-[13px] text-foreground font-medium text-right">{value}</span>
  </div>
);
